'use strict';

define('ImageViewer', ['native', 'swiper'], function (native, Swiper) {
	const ImageViewer = {};
	ImageViewer.view = function (images, current) {
		if (native.mock) {
			let htmlStr = '';
			images.forEach((i) => {
				htmlStr += `<div class="swiper-slide"><div class="swiper-img-wrapper"><img src="${i}" /></div></div>`;
			});

			const imagesHtml = `
				<div id="imagesViewerWrapper" class="swiper-modal hidden">
					<div class="swiper-bg"></div>
					<div class="swiper-navbar">
						<div class="btn-back">
							<i class="icon-nodeBB-back"></i>
						</div>
						<h4 class="title"></h4>
					</div>
					<div class="swiper-images">
						<div class="swiper-wrapper">
						${htmlStr}
						</div>
					</div>
				</div>`;
			$('body').append(imagesHtml);
			new Swiper('#imagesViewerWrapper .swiper-images', {
				loop: false, // 循环模式选项
				initialSlide: current || 0,
				pagination: {
					el: '#imagesViewerWrapper .title',
					type: 'fraction',
				},
			});
			$('#imagesViewerWrapper').removeClass('hidden');
			$('#imagesViewerWrapper').on('click', '.btn-back', () => {
				$('#imagesViewerWrapper').remove();
			});
		} else {
			native.previewMedia({
				current,
				images,
			});
		}
	};

	return ImageViewer;
});
